import React from 'react';

// Asks a chart's trend query for predicted buckets after its last one (see
// aggregateCompoundMetric's forecastPeriods), e.g. for Studio's Forecast.
// The predicted rows are kept out of the chart's data and handed back
// instead. Charts outside a provider don't forecast.
export interface ChartForecast {
  periods: number;
  // The predicted rows of the chart's latest response (none when the metric
  // has too little history, or the forecast failed)
  onPredictedRows: (rows: MetricsResponse) => void;
}

const ChartForecastContext = React.createContext<ChartForecast | undefined>(
  undefined,
);

export default ChartForecastContext;
